export enum SystemModule {
  AdsandFraudMonitoring = 'AdsandFraudMonitoring',
  DiscountsandCompetitionsComplianceVerification = 'DiscountsandCompetitionsComplianceVerification',
  PriceIndexandComparison = 'PriceIndexandComparison',
  ConsumerFriendsPartners = 'ConsumerFriendsPartners',
  StoreEvaluationandEconomicOperatorComplianceIndex = 'StoreEvaluationandEconomicOperatorComplianceIndex',
  ConsumerSubscriptionsManagement = 'ConsumerSubscriptionsManagement',
  DocumentsandInvoicesManagement = 'DocumentsandInvoicesManagement',
  LegalConsultationsandAISystem = 'LegalConsultationsandAISystem',
  TechnicalProductComparisonandLaboratoryTesting = 'TechnicalProductComparisonandLaboratoryTesting',
  SurveysandOpinionPolls = 'SurveysandOpinionPolls',
  RightsAndDutiesGuide = 'RightsandDutiesGuide',
  RightsandDuties = 'RightsandDuties',
  InstitutionRightsandDutiesGuide = 'InstitutionRightsandDutiesGuide',
  ConsumerAmbassador = 'ConsumerAmbassador',
  UserManagement = 'UserManagement',
  PlatformLevelGeneralSettings = 'PlatformLevelGeneralSettings',
  ConsumerVoiceServices = 'ConsumerVoiceServices',
  MyTasks = "MyTasks",
  Complaints = 'Complaints',
  OperatorComplaints = 'OperatorComplaints',
  ConsumerRightsandDutiesGuide = 'ConsumerRightsandDutiesGuide',
  AdminAcademy = 'AdminAcademy',
  AdvertisementsAndBanners = 'AdvertisementsAndBanners',
  UserAcademy = 'UserAcademy',
  ConsumerAcademy = 'ConsumerAcademy'
}
